import { Navbar } from "../shared/components/Navbar.js";
import { ApiService } from "../shared/services/ApiService.js";
import { AuthService } from "../shared/services/AuthService.js";
import { AppConfig } from "../shared/config/AppConfig.js";
import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import { GeoService } from "../shared/services/GeoService.js";
import { LocationSelectModule } from "../shared/components/LocationSelectModule.js";
import { AdjuntosService } from "../shared/services/AdjuntosService.js";

import servicesTemplate from "./templates/services.html?raw";
import vehiclesTemplate from "./templates/vehicles.html?raw";
import businessSelectorTemplate from "./templates/business-selector-modal.html?raw";
import businessDetailsTemplate from "./templates/business-details-modal.html?raw";
import crearPublicacionTemplate from "./templates/crear-publicacion-modal.html?raw";
import presupuestoTemplate from "./templates/presupuesto-modal.html?raw";

import Swal from "sweetalert2";
import Cleave from "cleave.js";

export const ServicesController = {

	siteNamePublicidad: AppConfig.app.name,
	seccionPublicidad: "quenecesitas",
	instPrecio: null,

	services: [
		{
			icon: "fas fa-shield-alt",
			title: "Asegurar un vehículo",
			description: "Cotiza y contrata seguros",
			action: "asegurar",
			requirePopBusiness: false,
			id: 1,
			prestadorServicios: [],
		},
		{
			icon: "fas fa-car-crash",
			title: "Reparar un Choque",
			description: "Reparación de daños por accidente",
			action: "crash-repair",
			requirePopBusiness: true,
			id: 2,
			prestadorServicios: [1, 2],
		},
		{
			icon: "fas fa-circle",
			title: "Cambiar Neumáticos",
			description: "Cambio e instalación de neumáticos",
			action: "tires",
			requirePopBusiness: true,
			id: 3,
			prestadorServicios: [14, 4],
		},
		{
			icon: "fas fa-window-maximize",
			title: "Reponer un Cristal",
			description: "Reparación y cambio de cristales",
			action: "glass",
			requirePopBusiness: true,
			provedoresEnBusiness: true,
			id: 4,
			prestadorServicios: [11],
			proveedorRubros: [0],
		},
		{
			icon: "fas fa-key",
			title: "Reparar una Cerradura",
			description: "Reparación de cerraduras y llaves",
			action: "locks",
			requirePopBusiness: true,
			provedoresEnBusiness: true,
			id: 5,
			prestadorServicios: [10],
			proveedorRubros: [0],
		},
		{
			icon: "fas fa-bolt",
			title: "Diagnóstico Eléctrico",
			description: "Diagnóstico de problemas eléctricos",
			action: "electrical",
			requirePopBusiness: true,
			id: 6,
			prestadorServicios: [13],
		},
		{
			icon: "fas fa-truck",
			title: "Auxilio Mecánico",
			description: "Asistencia mecánica y traslado",
			action: "assistance",
			requirePopBusiness: true,
			id: 7,
			prestadorServicios: [3, 5],
		},
		{
			icon: "fas fa-cog",
			title: "Autopartes y Repuestos",
			description: "Compra de repuestos y accesorios",
			action: "parts",
			requirePopBusiness: true,
			provedoresEnBusiness: true,
			proveedorRubros: [0],
			id: 8,
		},
		{
			icon: "fas fa-dollar-sign",
			title: "Vender mi auto",
			description: "Publica tu vehículo en venta",
			action: "sell",
			requirePopBusiness: false,
			id: 9,
		},
		{
			icon: "fas fa-shopping-cart",
			title: "Comprar un auto",
			description: "Busca vehículos en venta",
			action: "buy",
			requirePopBusiness: false,
			id: 10,
		},
		{
			icon: "fas fa-star",
			title: "Estética/Detail",
			description: "Servicios de estética automotriz",
			action: "detail",
			requirePopBusiness: true,
			id: 11,
			prestadorServicios: [12],
		},
		{
			icon: "fas fa-tint",
			title: "Lavar mi auto",
			description: "Servicios de lavado",
			action: "wash",
			requirePopBusiness: true,
			id: 12,
			prestadorServicios: [15],
		},
		{
			icon: "fas fa-music",
			title: "Equipamiento y Audio",
			description: "Instalación de equipos de audio",
			action: "audio",
			requirePopBusiness: true,
			id: 13,
			prestadorServicios: [16],
		},
		{
			icon: "fas fa-wrench",
			title: "Servicio de Mantenimiento",
			description: "Mantenimiento preventivo",
			action: "maintenance",
			requirePopBusiness: true,
			id: 14,
		},
		{
			icon: "fas fa-car",
			title: "Reparación de Suspensión",
			description: "Reparación del tren delantero",
			action: "suspension",
			requirePopBusiness: true,
			id: 15,
			prestadorServicios: [9],
		},
		{
			icon: "fas fa-screwdriver-wrench",
			title: "Reparación de motor",
			description: "Diagnóstico y reparación de motor",
			action: "engine",
			requirePopBusiness: true,
			id: 16,
			prestadorServicios: [7],
		},
		{
			icon: "fas fa-snowflake",
			title: "Climatización",
			description: "Servicios de climatización",
			action: "climate",
			requirePopBusiness: true,
			id: 17,
			prestadorServicios: [6],
		},
		{
			icon: "fas fa-file-invoice-dollar",
			title: "Presupuesto Online",
			description: "Presupuestá tu reparación",
			action: "presup",
			requirePopBusiness: false,
			id: 18,
			prestadorServicios: [],
		},

	],

	render: async () => {
		const adsHeader = await ApiService.get(`apiapp/obtenerpublicidad?sector=1&seccion=${ServicesController.seccionPublicidad}&sitio=${ServicesController.siteNamePublicidad}&cantidad=4`);

		const data = {
			services: ServicesController.services,
			adsHeader: adsHeader.ads || [],
		};
		const content = TemplateEngine.render(servicesTemplate, data);
		document.getElementById("app").innerHTML = await Navbar.render() + content;

		const user = AuthService.getCurrentUser();
		const respVehi = await ApiService.post("apiapp/ObtenerVehiculos", null, user?.token);
		const vehiclesOrig = respVehi.vehiculos || [];

		// vehículos válidos
		const vehicles = vehiclesOrig.filter(v =>
			v.Cedula &&
			v.Cedula !== "." &&
			v.Cedula.trim() !== "" &&

			v.Chasis &&
			v.Chasis !== "." &&
			v.Chasis.trim() !== "" &&

			v.Motor &&
			v.Motor !== "." &&
			v.Motor.trim() !== ""
		);

		//  detectamos si se quitó alguno
		const removedCount = vehiclesOrig.length - vehicles.length;


		if (vehicles.length === 0) {
			await Swal.fire({
				icon: "warning",
				title: "Datos incompletos",
				text: "Debes completar los datos del vehículo antes de continuar.",
				confirmButtonText: "Entendido"
			});
			window.location.href = "#vehicles";
			return; //  cortar flujo
		}


		if (removedCount > 0) {
			Swal.fire({
				toast: true,
				position: "top-end",
				icon: "info",
				title: `${removedCount} vehículo(s) fueron omitidos por datos incompletos`,
				showConfirmButton: false,
				timer: 4000,
				timerProgressBar: true
			});
		}



		document.querySelectorAll(".handelService").forEach((element) => {
			element.addEventListener("click", async () => {
				const action = element.dataset.action;
				await ServicesController.selectService(action);
			});
		});
	},

	selectService: async (serviceType) => {
		if (serviceType == 'buy') {
			await ServicesController.processService(serviceType, {}, false);
			return;
		}

		const vehicleData = await ServicesController.selectVehicle();
		if (!vehicleData) {
			return;
		}
		const service = ServicesController.services.find(s => s.action === serviceType);
		const { value: confirm } = await Swal.fire({
			title: "Servicio Seleccionado",
			text: `Has seleccionado: ${service.title} para el vehiculo ${vehicleData.Dominio}. ¿Deseas continuar?`,
			icon: "question",
			showCancelButton: true,
			confirmButtonText: "Continuar",
			cancelButtonText: "Cancelar",
		});

		if (confirm) {
			localStorage.setItem("ServiceToVehicle", vehicleData.Dominio);

			let BusinessGo = null;
			// Si el servicio requiere negocio, mostrar selector
			if (service.requirePopBusiness) {
				const selectedBusiness = await ServicesController.showBusinessSelector(service, vehicleData);
				if (!selectedBusiness) return;
				BusinessGo = await ServicesController.showBusinessDetails(selectedBusiness);
			}
			// Procesar el servicio con el vehículo y el negocio (si aplica)
			await ServicesController.processService(serviceType, vehicleData, BusinessGo);

		} else {
			Swal.fire("Cancelado", "El proceso ha sido cancelado.", "info");
		}
	},

	processService: async (serviceType, vehicleData, BusinessGo) => {
		try {
			const user = AuthService.getCurrentUser();
			const service = ServicesController.services.find(s => s.action === serviceType);

			if (!service) throw new Error("Servicio no reconocido.");
			if (vehicleData == null) throw new Error("No se ha seleccionado un vehículo.");
			let resp = null;

			if (service.requirePopBusiness && !BusinessGo) {
				throw new Error("Este servicio requiere seleccionar un negocio.");
			}

			if (BusinessGo) {
				try {
					await ApiService.post(
						"apiapp/servicioConfirmado",
						{
							dominio: vehicleData.Dominio,
							serviceId: service.id,
							businessId: BusinessGo.id,
							rating: 0,
							review: "",
						},
						user?.token
					);
				} catch (error) {
					//console.error("Error confirming service with business:", error);
				}
				Swal.fire("Servicio Confirmado", `Te enviaremos una solicitud de calificacion para el servicio de ${service.title}.`, "success");
				return;
			}

			switch (service.action) {
				case "asegurar": // tj 1
					resp = await ApiService.post("apiapp/SolicitudSeguro", { dominio: vehicleData.Dominio }, user?.token);
					if (!resp || resp.status != 1) {
						throw new Error("Error al enviar la solicitud de seguro.");
					}
					Swal.fire("Solicitud enviada", "Un productor se pondrá en contacto contigo para brindarte las cotizaciones.", "success");
					break;
				case "presup": // tj 18, presupuesto online
					await ServicesController.CrearPresupuestoOnline(vehicleData);
					break;
				// ya se maneja mostrando el selector de negocios, no hace falta acción directa
				/*
				case "glass": // tj 4
				case "locks": // tj 5
				case "parts": // tj 8
					window.location.href = "#quotes?new=1";
					break;
				*/
				case "sell": // tj 9
					// confirma si quiere editar datos del vehiculo o agregar fotos
					const { value: editChoice } = await Swal.fire({
						title: "¿Queres editar los datos del vehículo o agregar fotos?",
						icon: "question",
						showCancelButton: true,
						confirmButtonText: "Si, editar datos o fotos",
						cancelButtonText: "No, continuar publicación",
						allowOutsideClick: false,
					});

					if (editChoice) {
						location.href = `#vehicles`;
						return;
					}

					await ServicesController.CrearPublicacion(vehicleData);

					break;
				case "buy": // tj 10
					// abre pagina nueva en nueva pestaña
					window.open(AppConfig.tienda.url + "?action=buy", "_blank");
					break;
				default:
					Swal.fire("Error", "Tipo de servicio no reconocido.", "error");
					return;
			}
		} catch (error) {
			Swal.fire("Error", error.message || "Ocurrió un error al procesar el servicio.", "error");
		}
	},

	selectVehicle: async () => {


		let serviceToVehicle = localStorage.getItem("ServiceToVehicle");
		let vehicleData = null;
		const user = AuthService.getCurrentUser();

		if (serviceToVehicle != null) {
			const objvehicle = await ApiService.post("apiapp/ObtenerVehiculoDominio", { dominio: serviceToVehicle }, user?.token);
			vehicleData = objvehicle?.vehiculo;
		}

		if (serviceToVehicle == null) {
			const respVehi = await ApiService.post("apiapp/ObtenerVehiculos", null, user?.token);
			const vehiclesOrig = respVehi.vehiculos || [];

			// vehículos válidos
			const vehicles = vehiclesOrig.filter(v =>
				v.Cedula &&
				v.Cedula !== "." &&
				v.Cedula.trim() !== "" &&

				v.Chasis &&
				v.Chasis !== "." &&
				v.Chasis.trim() !== "" &&

				v.Motor &&
				v.Motor !== "." &&
				v.Motor.trim() !== ""
			);

			//  detectamos si se quitó alguno
			const removedCount = vehiclesOrig.length - vehicles.length;


			if (vehicles.length === 0) {
				await Swal.fire({
					icon: "warning",
					title: "Datos incompletos",
					text: "Debes completar los datos del vehículo antes de continuar.",
					confirmButtonText: "Entendido"
				});
				window.location.href = "#vehicles";
				return; //  cortar flujo
			}


			if (removedCount > 0) {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "info",
					title: `${removedCount} vehículo(s) fueron omitidos por datos incompletos`,
					showConfirmButton: false,
					timer: 4000,
					timerProgressBar: true
				});
			}




			const data = {
				vehicles
			};

			const modalContent = TemplateEngine.render(vehiclesTemplate, data);
			const { value: formValues } = await Swal.fire({
				title: "Seleccionar Vehículo",
				html: modalContent,
				width: 600,
				showCancelButton: true,
				confirmButtonText: "Seleccionar",
				cancelButtonText: "Cancelar",
				allowOutsideClick: false,
				preConfirm: () => {
					// 1. Obtener el radio button seleccionado
					const selectedRadio = document.querySelector('input[name="selectedVehicle"]:checked');

					// 2. Validar que hay algo seleccionado
					if (!selectedRadio) {
						Swal.showValidationMessage('Por favor selecciona un vehículo');
						return false;
					}

					// 3. Obtener el ID del vehículo
					const vehicleSelectedPop = selectedRadio.value;

					// 4. Buscar el objeto completo del vehículo
					const selectedVehicle = vehicles.find(v => v.Dominio === vehicleSelectedPop);

					// 5. Retornar el objeto completo
					return selectedVehicle;
				}
			});

			if (formValues) {
				vehicleData = formValues;
			}

		}
		return vehicleData;

	},


	showBusinessSelector: async (service, vehicleData) => {
		try {
			// carga de negocios
			const lstNeg = await ServicesController.loadBusinesses(service);

			if (!lstNeg) {
				return null; // canceló selección de provincia
			}
			if (lstNeg.length === 0) {
				const result = await Swal.fire({
					title: '<i class="fas fa-store me-2"></i>Sin Negocios Cercanos',
					html: `
					No se encontraron negocios cercanos que ofrezcan este servicio. 
					<p>¿Deseas crear un presupuesto online para recibir cotizaciones?</p>`
					,
					width: 900,
					icon: "info",
					showCancelButton: true,
					confirmButtonText: "Si, crear presupuesto online",
					cancelButtonText: "Cancelar",
					allowOutsideClick: false,
				});

				if (result.isConfirmed) {
					if (service.provedoresEnBusiness) {
						//si busco proveedores, entonces voy a cotizaciones, sino a la creacion del presupuesto online
						window.location.href = "#quotes?new=1";
					} else {
						ServicesController.CrearPresupuestoOnline(vehicleData);
					}
				}

				return null;
			}

			const processedBusinesses = lstNeg.map((business) => ({
				...business,
				starsHtml: TemplateEngine.helpers.generateStars(business.rating),
				ratingDisplay: business.rating.toFixed(1),
			}));
			const data = {
				businesses: processedBusinesses,
				noBusinesses: lstNeg.length === 0,
			};

			const modalContent = TemplateEngine.render(businessSelectorTemplate, data);

			const result = await Swal.fire({
				title: '<i class="fas fa-store me-2"></i>Seleccionar Negocio',
				html: modalContent,
				width: 900,
				showCancelButton: true,
				confirmButtonText: "Ver Detalles",
				cancelButtonText: "Cancelar",
				customClass: {
					popup: "business-selector-popup",
				},
				allowOutsideClick: false,
				didOpen: () => {
					// Agregar evento al botón de presupuesto online
					const btnPresup = document.getElementById("btnPresup");
					if (btnPresup) {
						btnPresup.addEventListener("click", () => {
							Swal.close();
							if (service.provedoresEnBusiness) {
								//si busco proveedores, entonces voy a cotizaciones, sino a la creacion del presupuesto online
								window.location.href = "#quotes?new=1";
							} else {
								ServicesController.CrearPresupuestoOnline(vehicleData);
							}
						});
					}
				},
				preConfirm: () => {
					const selectedRadio = document.querySelector('input[name="selectedBusiness"]:checked');

					if (!selectedRadio) {
						Swal.showValidationMessage("Por favor selecciona un negocio");
						return false;
					}

					const businessId = Number.parseInt(selectedRadio.value);
					const selectedBusiness = lstNeg.find((b) => b.id === businessId);

					return selectedBusiness;
				},
			});

			return result.isConfirmed ? result.value : null;
		} catch (error) {
			console.error("Error loading businesses:", error);
			Swal.fire("Error", "No se pudieron cargar los negocios", "error");
			return null;
		}
	},

	showBusinessDetails: async (business) => {
		const data = {
			...business,
			starsHtml: TemplateEngine.helpers.generateStars(business.rating),
			ratingDisplay: business.rating.toFixed(1),
			reviewCount: business.reviewCount || 0,
		};
		const modalContent = TemplateEngine.render(businessDetailsTemplate, data);

		const businessAtt = await Swal.fire({
			title: false,
			html: modalContent,
			width: 1000,
			showCancelButton: true,
			confirmButtonText: "Me sirve, los contactaré",
			cancelButtonText: "Cerrar",
			customClass: {
				popup: "business-details-popup",
			},
			allowOutsideClick: false,
			preConfirm: () => {
				return business;
			},
		});

		return businessAtt;
	},

	CrearPublicacion: async (vehicleData) => {
		try {
			const user = AuthService.getCurrentUser();
			if (!user) throw new Error("Usuario no autenticado.");

			const respFotos = await ApiService.post(`apiapp/ObtenerFotosVehiculo`, { Dominio: vehicleData.Dominio }, user?.token);

			const data = {
				...vehicleData,
				photos: respFotos?.fotos || [],
				kilometers: vehicleData.Kilometraje.toLocaleString(),
			};


			const modalContent = TemplateEngine.render(crearPublicacionTemplate, data);

			const result = await Swal.fire({
				title: '<i class="fas fa-dollar-sign me-2"></i>Crear Publicación de Venta',
				html: modalContent,
				width: 1000,
				showCancelButton: true,
				confirmButtonText: "Publicar Vehículo",
				cancelButtonText: "Cancelar",
				customClass: {
					popup: "crear-publicacion-popup",
				},
				didOpen: () => {
					ServicesController.setupPublicacionModal();
				},
				preConfirm: () => {
					return ServicesController.validatePublicacionForm();
				},
			});

			if (!result.isConfirmed) {
				return;
			}

			console.log(vehicleData);
			console.log(result.value);
			const dataPubli = result.value;

			if (!dataPubli) {
				return;
			}

			if (dataPubli.financiacion) dataPubli.descripcion += "\n\n*Financiación disponible*";
			if (dataPubli.negociable) dataPubli.descripcion += "\n\n*Precio Negociable*";
			if (dataPubli.permutaPorMenor) dataPubli.descripcion += "\n\n*Permuto por vehículo de menor valor*";

			const publicationData = {
				dominio: vehicleData.Dominio,
				marca: vehicleData.Marca,
				modelo: vehicleData.Modelo,
				anio: vehicleData.Anio,
				km: vehicleData.Kilometraje,
				color: vehicleData.Color,
				puertas: 0, // lo toma del modelo de auto seleccionado
				combustible: dataPubli.combustible,
				precio: dataPubli.precio || 0,
				descripcion: dataPubli.descripcion || "",
				fotos: dataPubli.selectedPhotos || [],
			};

			const resp = await ApiService.post("apiapp/CrearPublicacion", publicationData, user?.token);
			if (!resp || resp.status != 1) {
				throw new Error(resp?.message || "Error al crear la publicación.");
			}

			await Swal.fire("Publicación Creada", "Tu vehículo será publicado próximamente en los canales asociados.", "success");
		} catch (error) {
			await Swal.fire("Error", error.message || "Ocurrió un error al crear la publicación.", "error");
		}
	},

	CrearPresupuestoOnline: async (vehicleData) => {
		try {
			const user = AuthService.getCurrentUser();
			if (!user) throw new Error("Usuario no autenticado.");

			const result = await Swal.fire({
				title: '<i class="fas fa-file-invoice-dollar me-2"></i>Crear Presupuesto Online',
				html: presupuestoTemplate,
				width: 650,
				showCancelButton: true,
				confirmButtonText: "Continuar",
				cancelButtonText: "Cancelar",
				allowOutsideClick: false,
				focusConfirm: false,
				didOpen: async () => {
					document.getElementById("inputTitulo")?.focus();

					const selectTipoServicio = document.getElementById("selectTipoServicio");

					try {
						const resp = await ApiService.get("Prestador_Servicio/ObtenerTrabajos?Id=0");

						if (resp?.status > 0 && Array.isArray(resp.message)) {
							resp.message.forEach(item => {
								const opt = document.createElement("option");
								opt.value = item.IdServicio;
								opt.textContent = item.Servicio;
								selectTipoServicio.appendChild(opt);
							});
						}
					} catch (e) {
						console.error("Error cargando tipos de servicio", e);
					}
				},

				preConfirm: () => {
					const titulo = document.getElementById("inputTitulo")?.value?.trim();
					const descripcion = document.getElementById("inputDescripcion")?.value?.trim();
					const movilizable = document.getElementById("chkMovilizable")?.checked === true;
					const idTipoServicio = document.getElementById("selectTipoServicio")?.value;
					if (!titulo) {
						Swal.showValidationMessage("Ingresá un título");
						return false;
					}

					if (!descripcion) {
						Swal.showValidationMessage("Ingresá una descripción");
						return false;
					}
					if (!idTipoServicio) {
						Swal.showValidationMessage("Seleccioná un tipo de servicio");
						return false;
					}

					const payload = { titulo, descripcion, movilizable, idTipoServicio: Number(idTipoServicio) };
					return payload;
				},
			});

			if (!result.isConfirmed) return null;

			const { titulo, descripcion, movilizable, idTipoServicio } = result.value;

			const Zona = await LocationSelectModule.pick({
				title: "Completá tu ubicación",
				showLocalidad: true,
				loadSavedLocation: true,
			});

			if (!Zona) {
				await Swal.fire("Cancelado", "Debes completar tu ubicación para continuar.", "info");
				return;
			}
			const nombresAdjuntos = await AdjuntosService.openUploaderModal({
				token: user?.token,
				max: 6,
				showEnviarSinAdjuntos: false,
				minimoRequerido: 1
			});

			if (nombresAdjuntos === null) return;

			if (nombresAdjuntos.length === 0) {
				await Swal.fire("Cancelado", "Debes adjuntar al menos un archivo para continuar.", "info");
				return;
			}

			const adjuntosQS = AdjuntosService.buildAdjuntosQuery(nombresAdjuntos);

			const presupOnlineApi = {
				IdVehiculoReal: vehicleData.IdVehiculoReal,
				Dominio: vehicleData.Dominio,
				Chasis: vehicleData.Chasis,
				Motor: vehicleData.Motor,
				Cedula: vehicleData.Cedula,
				DiasValidez: 10,
				ZonaIdPais: Zona.paisId || 0,
				ZonaIdProvincia: Zona.provinciaId || 0,
				ZonaIdLocalidad: Zona.localidadId || 0,
				Titulo: titulo,
				Descripcion: descripcion,
				Movilizable: movilizable,
				IdTipoServicio: idTipoServicio,
			};
			const objPresupuesto = await ApiService.post(`apiapp/PresupuestoOnline?Adjuntos=${encodeURIComponent(adjuntosQS)}`, presupOnlineApi, user?.token);
			if (objPresupuesto?.status < 1) {
				throw new Error("Error enviando datos de presupuesto a la API");
			}

			await Swal.fire({
				html: `
					<h2>Presupuesto creado correctamente.</h2> 
					<p>Espera a la fecha de vencimiento para ver las cotizaciones en la sección de presupuestos.</p>
					<p class="text-muted">El código de presupuesto es: </p>
					<p class="text-muted">${objPresupuesto?.message?.Codigo}</p>
					`,
				icon: "success",
			});



		}
		catch (error) {
			await Swal.fire("Error", error.message || "Ocurrió un error al solicitar el presupuesto online.", "error");
		}
	},

	setupPublicacionModal: () => {
		// Configurar contador de fotos seleccionadas
		const photoCheckboxes = document.querySelectorAll('input[name="selectedPhotos"]');
		const selectedCountSpan = document.getElementById("selectedCount");

		const updatePhotoCount = () => {
			const selectedPhotos = document.querySelectorAll('input[name="selectedPhotos"]:checked');
			selectedCountSpan.textContent = selectedPhotos.length;

			// Limitar a máximo 4 fotos
			if (selectedPhotos.length >= 4) {
				photoCheckboxes.forEach((checkbox) => {
					if (!checkbox.checked) {
						checkbox.disabled = true;
					}
				});
			} else {
				photoCheckboxes.forEach((checkbox) => {
					checkbox.disabled = false;
				});
			}
		};

		photoCheckboxes.forEach((checkbox) => {
			checkbox.addEventListener("change", updatePhotoCount);
		});

		// Configurar preview de descripción
		const descripcionTextarea = document.querySelector('textarea[name="descripcion"]');
		const charCount = document.getElementById("charCount");

		const updateCounter = () => {
			const descripcion = descripcionTextarea.value;
			charCount.textContent = descripcion.length;
		};

		descripcionTextarea.addEventListener("input", updateCounter);

		ServicesController.instPrecio = new Cleave('#precioInput', {
			numeral: true,
			numeralThousandsGroupStyle: 'thousand',
			numeralDecimalMark: ',',
			delimiter: '.'
		});

		updatePhotoCount();
		updateCounter();
	},

	validatePublicacionForm: () => {
		const selectedPhotos = document.querySelectorAll('input[name="selectedPhotos"]:checked');
		const descripcion = document.querySelector('textarea[name="descripcion"]').value;
		const combustible = document.querySelector('#combustibleSelect').value;
		const precio = ServicesController.instPrecio.getRawValue();


		// Validar que se haya seleccionado al menos una foto
		if (selectedPhotos.length === 0) {
			Swal.showValidationMessage("Debes seleccionar al menos una foto");
			return false;
		}

		// Validar precio
		if (!precio || precio <= 0) {
			Swal.showValidationMessage("Debes ingresar un precio válido");
			return false;
		}

		// Validar combustible
		if (!combustible || combustible == "") {
			Swal.showValidationMessage("Debes seleccionar un tipo de combustible válido");
			return false;
		}

		// Validar descripción
		if (!descripcion.trim()) {
			Swal.showValidationMessage("Debes agregar una descripción");
			return false;
		}

		if (descripcion.length < 20) {
			Swal.showValidationMessage("La descripción debe tener al menos 20 caracteres");
			return false;
		}

		// Recopilar datos del formulario
		const formData = {
			selectedPhotos: Array.from(selectedPhotos).map((cb) => cb.value),
			precio: Number.parseInt(precio),
			descripcion: descripcion.trim(),
			negociable: document.getElementById("negociable").checked,
			permutaPorMenor: document.getElementById("permutaPorMenor").checked,
			financiacion: document.getElementById("financiacion").checked,
		};

		return formData;
	},

	loadBusinesses: async (service) => {


		const idProvincia = await LocationSelectModule.preguntarProvincia(null, { alwaysAsk: true });
		if (!idProvincia) return null; // canceló

		const { lat, lng } = await GeoService.getCurrentLocationOrDefault();

		const parametros = {
			Latitud: lat,
			Longitud: lng,
			IdProvincia: idProvincia,
			IdServicio: service.provedoresEnBusiness ? service.proveedorRubros.join(",") : service.prestadorServicios.join(","),
			PideRepuesto: service.provedoresEnBusiness ?? false, // solo para autopartes y repuestos
		};

		const qs = new URLSearchParams(parametros).toString();

		const presta = await ApiService.get(`apiapp/NegociosCercanos?${qs}`);

		if (!presta || presta.status != 1) return [];

		const prestadoresApp = presta.message.map(p => ({
			id: p.Id,
			name: p.Nombre || "",
			address: p.Direccion || "",
			city: p.Localidad || "",
			phone: (p.Telefono || "") + " - " + (p.Celular || ""),
			whatsapp: (p.Celular || "") != '' ? `https://api.whatsapp.com/send?phone=549${p.Celular}&text=Quiero consultarles....` : '',
			schedule: p.Horarios || "",
			rating: p.Calificacion || 0,
			distance: p.DistanciaKm ?? 0,
			logo: p.Logo || "",
			coverImage: p.Banner || "",
			specialties: p.ServiciosDestacados || [],
			description: p.Descripcion || "",
			services: p.Ofertas || [],
			website: p.Website || "",
			reviewCount: p.CantidadCalificaciones || 0,
			serviceType: service.serviceType
		}));
		return prestadoresApp;

	},

};
